import React, { useState } from "react";
import styles from "./index.module.scss";
import Form, { useForm } from "rc-field-form";
import { Button, Input, Modal, Radio } from "antd";
import useDeviceType from "Utils/useDeviceType";
import { FeedbackData, FeedbackType, saveFeedback } from "API/app";
import FileUploader from "./Components/FileUploader";
import useRequestFn from "../../Utils/useRequestFn";
import { ValidateErrorEntity } from "rc-field-form/es/interface";
import FieldError from "./Components/FieldError";
import { useHeaderProps } from "../../components/Layouts/SubLayout/useHeaderProps";

const logoUrl = require("./img/logo.png");
const logoUrlMobile = require("./img/logo-mobile.png");

export default function Feedback() {
    const [form] = useForm<FeedbackData>();
    const { isPC } = useDeviceType();
    const [errors, setErrors] = useState<any>();
    const [done, setDone] = useState(false);

    useHeaderProps({ title: "问题反馈" });

    function getError(name: string) {
        return errors?.find((item: any) => item.name[0] === name)?.errors;
    }

    function onError(e: ValidateErrorEntity) {
        setErrors(e.errorFields);
    }

    const [onSubmit, { loading }] = useRequestFn(async (data: FeedbackData) => {
        await saveFeedback(data);
        Modal.success({
            content:
                "您的反馈提交成功，请耐心等待，我们的工作人员会在24 小时内解决并联系您。感谢您的支持和反馈!"
        });
        setDone(true);
    });

    return (
        <div className={styles.root}>
            <div className={styles.logo}>
                <img src={isPC ? logoUrl : logoUrlMobile} alt="" />
            </div>

            <div className={styles.body}>
                <Form
                    form={form}
                    className={styles.form}
                    onFinish={onSubmit}
                    onFinishFailed={onError}>
                    <div className={styles.question}>
                        <h2 className={styles.label}>
                            1. 您要反馈的问题是哪个类型呢？
                        </h2>

                        <Form.Field
                            name="type"
                            rules={[
                                { required: true, message: "请选择问题类型" }
                            ]}>
                            <Radio.Group disabled={done}>
                                <Radio value={FeedbackType.Bug}>平台缺陷</Radio>
                                <Radio value={FeedbackType.Suggestion}>
                                    功能建议
                                </Radio>
                                <Radio value={FeedbackType.Requirement}>
                                    新需求
                                </Radio>
                            </Radio.Group>
                        </Form.Field>

                        <FieldError error={getError("type")} />
                    </div>

                    <div className={styles.question}>
                        <h2 className={styles.label}>
                            2. 请详细描述您遇到的问题
                        </h2>

                        <Form.Field
                            name="value"
                            rules={[
                                {
                                    required: true,
                                    message: "请描述您遇到的问题"
                                }
                            ]}>
                            <Input.TextArea
                                className={styles.textArea}
                                maxLength={5000}
                                placeholder="详细描述您遇到的问题, 可方便我们定位您的问题哦."
                                disabled={done}
                            />
                        </Form.Field>

                        <FieldError error={getError("value")} />
                    </div>

                    <div className={styles.question}>
                        <h2 className={styles.label}>
                            3.
                            建议您上传遇到的问题截图，可以帮助我们排查问题原因
                        </h2>

                        <Form.Field name="pic">
                            <FileUploader disabled={done} />
                        </Form.Field>
                    </div>

                    <div className={styles.question}>
                        <h2 className={styles.label}>
                            4. 如果系统管理员联系您，如何称呼？
                        </h2>

                        <Form.Field name="nickname">
                            <Input
                                placeholder="请填写称呼"
                                maxLength={100}
                                disabled={done}
                            />
                        </Form.Field>
                    </div>

                    <div className={styles.question}>
                        <h2 className={styles.label}>
                            5. 为了详细了解问题，请留下您的联系方式
                        </h2>

                        <Form.Field name="phone">
                            <Input
                                placeholder="仅必要情况下联系，不会骚扰"
                                maxLength={100}
                                disabled={done}
                            />
                        </Form.Field>
                    </div>

                    <div className={styles.question}>
                        <h2 className={styles.label}>
                            6. 为了能及时反馈，请留下您的邮箱
                        </h2>

                        <Form.Field
                            name="mail"
                            rules={[
                                {
                                    type: "email",
                                    message: "请填写有效的邮箱地址"
                                }
                            ]}>
                            <Input
                                placeholder="仅必要情况下联系，不会骚扰"
                                maxLength={100}
                                disabled={done}
                            />
                        </Form.Field>

                        <FieldError error={getError("mail")} />
                    </div>
                </Form>

                <div className={styles.footer}>
                    <Button
                        type="primary"
                        loading={loading}
                        onClick={() => form.submit()}
                        disabled={done}>
                        提交反馈
                    </Button>
                </div>
            </div>
        </div>
    );
}
